// FETCH ALL PROPERTIES FROM YARN_PO DETAILS
export const FETCH_YARN_PO_DETAILS_REQUEST_DK = 'FETCH_YARN_PO_DETAILS_REQUEST_DK';
export const FETCH_YARN_PO_DETAILS_SUCCESS_DK = 'FETCH_YARN_PO_DETAILS_SUCCESS_DK';
export const FETCH_YARN_PO_DETAILS_FAILURE_DK = 'FETCH_YARN_PO_DETAILS_FAILURE_DK';

// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_YARN_PO_DETAILS_GROUP_LIST_REQUEST_DK = 'FETCH_YARN_PO_DETAILS_GROUP_LIST_REQUEST_DK';
export const FETCH_YARN_PO_DETAILS_GROUP_LIST_SUCCESS_DK = 'FETCH_YARN_PO_DETAILS_GROUP_LIST_SUCCESS_DK';
export const FETCH_YARN_PO_DETAILS_GROUP_LIST_FAILURE_DK = 'FETCH_YARN_PO_DETAILS_GROUP_LIST_FAILURE_DK';

// FETCH ALL PROPERTIES FROM YARN_PO DETAILS BY ID
export const FETCH_YARN_PO_DETAILS_BY_ID_REQUEST_DK = 'FETCH_YARN_PO_DETAILS_BY_ID_REQUEST_DK';
export const FETCH_YARN_PO_DETAILS_BY_ID_SUCCESS_DK = 'FETCH_YARN_PO_DETAILS_BY_ID_SUCCESS_DK';
export const FETCH_YARN_PO_DETAILS_BY_ID_FAILURE_DK = 'FETCH_YARN_PO_DETAILS_BY_ID_FAILURE_DK';

// CREATE PROPERTIES FOR YARN_PO DETAILS
export const CREATE_YARN_PO_DETAILS_REQUEST_DK = 'CREATE_YARN_PO_DETAILS_REQUEST_DK';
export const CREATE_YARN_PO_DETAILS_SUCCESS_DK = 'CREATE_YARN_PO_DETAILS_SUCCESS_DK';
export const CREATE_YARN_PO_DETAILS_FAILURE_DK = 'CREATE_YARN_PO_DETAILS_FAILURE_DK';

export const FETCH_YARN_PO_PREVIOUS_LIST_REQUEST_DK = 'FETCH_YARN_PO_PREVIOUS_LIST_REQUEST_DK';
export const FETCH_YARN_PO_PREVIOUS_LIST_SUCCESS_DK = 'FETCH_YARN_PO_PREVIOUS_LIST_SUCCESS_DK';
export const FETCH_YARN_PO_PREVIOUS_LIST_FAILURE_DK = 'FETCH_YARN_PO_PREVIOUS_LIST_FAILURE_DK';

//CREATE USER FORM
export const CREATE_USER_FORM_YARN_PO_DETAILS_DK = 'CREATE_USER_FORM_YARN_PO_DETAILS_DK';

// UPDATE PROPERTIES FOR YARN_PO DETAILS
export const UPDATE_YARN_PO_DETAILS_REQUEST_DK = 'UPDATE_YARN_PO_DETAILS_REQUEST_DK';
export const UPDATE_YARN_PO_DETAILS_SUCCESS_DK = 'UPDATE_YARN_PO_DETAILS_SUCCESS_DK';
export const UPDATE_YARN_PO_DETAILS_FAILURE_DK = 'UPDATE_YARN_PO_DETAILS_FAILURE_DK';

// FETCH SINGLE YARN_PO_DETAILS
export const FETCH_SINGLE_YARN_PO_DETAILS_REQUEST_DK = 'FETCH_SINGLE_YARN_PO_DETAILS_REQUEST_DK';
export const FETCH_SINGLE_YARN_PO_DETAILS_SUCCESS_DK = 'FETCH_SINGLE_YARN_PO_DETAILS_SUCCESS_DK';
export const FETCH_SINGLE_YARN_PO_DETAILS_FAILURE_DK = 'FETCH_SINGLE_YARN_PO_DETAILS_FAILURE_DK';

// DELETE PROPERTIES FOR YARN_PO DETAILS
export const DELETE_YARN_PO_DETAILS_REQUEST_DK = 'DELETE_YARN_PO_DETAILS_REQUEST_DK';
export const DELETE_YARN_PO_DETAILS_SUCCESS_DK = 'DELETE_YARN_PO_DETAILS_SUCCESS_DK';
export const DELETE_YARN_PO_DETAILS_FAILURE_DK = 'DELETE_YARN_PO_DETAILS_FAILURE_DK';

// USERFORM RESET

export const YARN_PO_DETAILS_USERFORM_RESET_DK = 'YARN_PO_DETAILS_USERFORM_RESET_DK';



export const CLOSE_BTN_POST_REQUEST = 'CLOSE_BTN_POST_REQUEST'
export const CLOSE_BTN_POST_SUCCESS = 'CLOSE_BTN_POST_SUCCESS'
export const CLOSE_BTN_POST_FALIURE = 'CLOSE_BTN_POST_FALIURE'



export const CHECK_ALL_UPDATE_REQUEST = 'CHECK_ALL_UPDATE_REQUEST'
export const CHECK_ALL_UPDATE_SUCCESS = 'CHECK_ALL_UPDATE_SUCCESS'
export const CHECK_ALL_UPDATE_FALIURE = 'CHECK_ALL_UPDATE_FALIURE'

export const YARN_CLOSE_BTN_POST_REQUEST = 'YARN_CLOSE_BTN_POST_REQUEST'
export const YARN_CLOSE_BTN_POST_SUCCESS = 'YARN_CLOSE_BTN_POST_SUCCESS'
export const YARN_CLOSE_BTN_POST_FAILURE = 'YARN_CLOSE_BTN_POST_FAILURE'



export const YARN_CHECK_ALL_UPDATE_REQUEST = 'YARN_CHECK_ALL_UPDATE_REQUEST'
export const YARN_CHECK_ALL_UPDATE_SUCCESS = 'YARN_CHECK_ALL_UPDATE_SUCCESS'
export const YARN_CHECK_ALL_UPDATE_FALIURE = 'YARN_CHECK_ALL_UPDATE_FALIURE'
